module.exports = __webpack_public_path__ + "static/media/errors-type-spec.4f62834a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/errors-type-spec.png
// module id = 472
// module chunks = 0